import { render, staticRenderFns } from "./Payees.vue?vue&type=template&id=1aac4cbe&scoped=true"
import script from "./Payees.vue?vue&type=script&lang=js"
export * from "./Payees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac4cbe",
  null
  
)

export default component.exports